import { render, staticRenderFns } from "./LeadItem.vue?vue&type=template&id=63be959d&"
import script from "./LeadItem.vue?vue&type=script&lang=ts&"
export * from "./LeadItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports